import React, { useState } from 'react';
import Avatar, { genConfig } from 'react-nice-avatar';
import Grid from '@mui/material/Grid';
import './AvatarSelector.css'

const AvatarSelector = ({ onSelectAvatar }) => {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [avatarKey, setAvatarKey] = useState(0);

  const handleAvatarSelect = (avatarConfig) => {
    setSelectedAvatar(avatarConfig);
    onSelectAvatar(avatarConfig);

  };

  const renderAvatars = () => {
    return Array.from({ length: 15 }, (_, index) => {
      const config = genConfig('avatar-' + index);
      const isSelected = JSON.stringify(config) === JSON.stringify(selectedAvatar);
      return (
        <Grid item>
          <div className={`${isSelected ? 'avatar-selected' : ''}`}
            onClick={() => handleAvatarSelect(config)}
          >
            <Avatar
              className={'avatar-selector'}
              {...config}
            />
          </div>
        </Grid>
      );
    });
  };

  return (
    <>
      <Grid mt={2} container spacing={2} className="avatar-selector-grid">
        {renderAvatars()}
      </Grid>
    </>
  );
};

export default AvatarSelector;
